import { render, staticRenderFns } from "./resetdialog.vue?vue&type=template&id=cf976d56&scoped=true"
import script from "./resetdialog.vue?vue&type=script&lang=js"
export * from "./resetdialog.vue?vue&type=script&lang=js"
import style0 from "./resetdialog.vue?vue&type=style&index=0&id=cf976d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf976d56",
  null
  
)

export default component.exports